"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcBoilVolumes = exports.calcMashVolumes = void 0;
const utils_1 = require("./utils");
const units_1 = require("./units");
const defaultBoil = {
    pre_boil_size: {
        value: 0,
        unit: 'gal',
    },
    boil_time: {
        value: 0,
        unit: 'min',
    },
};
const coolingShrinkageRate = 0.04;
const convertToGallons = (volume) => units_1.convertMeasurableValue(volume, 'gal');
// 0.96 - number of fl. ounces of water absorbed per ounce of the grain
// 128 fl. ounces in gallon, 16 ounces in pound
const grainAbsorptionRatio = (0.96 / 128) * 16;
const calcGrainAbsorption = (grainWeight) => {
    const value = units_1.convertMeasurableValue(grainWeight, 'lb') * grainAbsorptionRatio;
    return {
        value,
        unit: 'gal',
    };
};
const calcMashWaterVolume = (mash_steps = []) => {
    const value = utils_1.sum(mash_steps.map(({ type, amount }) => type === 'infusion' ? convertToGallons(amount) : 0));
    return {
        value,
        unit: 'gal',
    };
};
const calcMashVolumes = (pre_boil_size, mashSteps, mashGrainWeight, equipment) => {
    const mashWaterVolume = calcMashWaterVolume(mashSteps);
    const grainAbsorption = calcGrainAbsorption(mashGrainWeight);
    const mashLoss = equipment.mash_tun != null ? convertToGallons(equipment.mash_tun.loss) : 0;
    const spargeVolumeValue = convertToGallons(pre_boil_size) +
        grainAbsorption.value -
        mashWaterVolume.value +
        mashLoss;
    const spargeVolume = {
        value: spargeVolumeValue,
        unit: 'gal',
    };
    const totalVolume = {
        value: mashWaterVolume.value + spargeVolume.value,
        unit: 'gal',
    };
    return {
        mash_volume: mashWaterVolume,
        sparge_volume: spargeVolume,
        total_volume: totalVolume,
    };
};
exports.calcMashVolumes = calcMashVolumes;
const calcBoilVolumes = (batch_size, boil = defaultBoil, equipment) => {
    const boilProfile = boil || defaultBoil;
    const postBoilVolume = convertToGallons(batch_size);
    let boilLoss = 0;
    let boilRate = 0;
    if (equipment != null && equipment.brew_kettle != null) {
        boilLoss = convertToGallons(equipment.brew_kettle.loss);
        boilRate = convertToGallons(equipment.brew_kettle.boil_rate_per_hour);
    }
    const boilOffVolume = (boilRate * boilProfile.boil_time.value) / 60;
    const coolingShrinkage = postBoilVolume * coolingShrinkageRate;
    const preBoilVolume = postBoilVolume + boilOffVolume + boilLoss + coolingShrinkage;
    return {
        pre_boil_size: {
            value: preBoilVolume,
            unit: 'gal',
        },
    };
};
exports.calcBoilVolumes = calcBoilVolumes;
//# sourceMappingURL=volumes.js.map